// extracted by mini-css-extract-plugin
module.exports = {"passwordRecoveryButton":"styles_passwordRecoveryButton__3kQVA"};